import React from 'react'
import { IStoreListProps } from '../types'
import { StoreItem } from './StoreItem'
import { EmptyState } from './EmptyState'
import Divider from '@amzn/meridian/divider'
import './StoreList.scss'

/**
 * StoreList Component
 *
 * Container for store items with vertical scrolling.
 * Renders a StoreItem for each store and passes click handler to each item.
 * Shows empty state when no stores are available.
 */
export const StoreList: React.FC<IStoreListProps> = ({
    stores,
    onStoreClick,
    currentStoreId,
    selectedStoreId,
}) => {
  // Show empty state if no stores
    if (stores.length === 0) {
        return <EmptyState />
    }

    return (
      <div className="store-list">
        {stores.map((store) => (
          <React.Fragment key={store.storeId}>
            <StoreItem
              store={store}
              onClick={onStoreClick}
              isCurrent={store.storeId === currentStoreId}
              isSelected={store.storeId === selectedStoreId}
            />
            <Divider size="small"/>
          </React.Fragment>
        ))}
      </div>
    )
}
